import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';
import { cn } from '../ui/utils';

/**
 * Activity filter tabs.
 * `underline` matches the desktop reference; `pills` matches the mobile reference.
 */
function ActivityTabBar({ tabs, selectedTab, onTabChange, variant = 'underline' }) {
  const isPills = variant === 'pills';

  return (
    <Tabs value={selectedTab} onValueChange={onTabChange} className="gap-0">
      <TabsList
        className={cn(
          isPills
            ? 'flex h-auto w-full gap-1 rounded-xl bg-gray-100/70 p-1'
            : 'flex h-auto w-full justify-start gap-0 overflow-x-auto overflow-y-hidden rounded-none border-b border-gray-200 bg-transparent p-0'
        )}
      >
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            className={cn(
              isPills
                ? cn(
                    'h-auto flex-1 rounded-lg border-0 px-2 py-1.5 text-xs font-medium shadow-none',
                    'data-[state=active]:bg-white data-[state=active]:text-blue-600 data-[state=active]:shadow-sm',
                    'data-[state=inactive]:text-gray-600'
                  )
                : cn(
                    'h-auto flex-none rounded-none border-0 border-b-2 border-transparent bg-transparent px-4 py-3 text-sm font-medium whitespace-nowrap shadow-none -mb-px',
                    'text-gray-500 hover:border-gray-300 hover:text-gray-700',
                    'data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none'
                  )
            )}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}

export default ActivityTabBar;
